import React from 'react'
import Modal from 'components/common/Modal'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import HTMLContainer from 'components/common/HTMLContainer/HTMLContainer'

const CurbsideServiceModal = ({
  data: {
    modalBoxContent = []
  } = {},
  handleHide
}) =>
  <CustomModal title="" closeHandler={ handleHide } >
    {
      modalBoxContent.map(({ content }, index) =>
        <HTMLContainer key={ index } content={ content } />
      )
    }
  </CustomModal>

CurbsideServiceModal.propTypes = {
  data: PropTypes.shape(),
  handleHide: PropTypes.func
}

export default CurbsideServiceModal

const CustomModal = styled(Modal)`
  text-align: center;
`
